import { gql } from '@apollo/client';

export const GET_CASE_MANAGEMENT_ACTIVITY = gql`
  query GetCaseManagementActivity($activityId: ID!) {
    caseManagementActivity: getCaseManagementActivity(activityId: $activityId) {
      id
      examinationCardCategories {
        id
        name
      }
      examinationCardServices {
        id
        name
      }
      servicesCardCategories {
        id
        name
      }
      servicesCardServices {
        id
        name
      }
      diagnosisCardCategories {
        id
        name
      }
      diagnosisCardServices {
        id
        name
      }
      assessmentCardCategories {
        id
        name
      }
      assessmentCardServices {
        id
        name
      }
      casePlanCardCategories {
        id
        name
      }
      casePlanCardServices {
        id
        name
      }
      hiddenFields
    }
  }
`;
